import React, { Component } from 'react';
import * as Http from '../../http'
import * as Business from '../../utils/business'
import Loading from '../../components/Loading'
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';
import { LimitRecord } from '../../const';
import srcSlideTwo from '../../assets/dashboard/slide_2.png';


export default class CreditRisk extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      date: moment().local().endOf('day'),
      isShowDashboard: false
    }
  }

  componentDidMount() { }

  handleEffectShowDashboard() {
    this.setState({ loading: true }, () => {
      setTimeout(() => {
        this.setState({ loading: false, isShowDashboard: true })
      }, 500)
    });
  }

  renderDashboard() {
    if (this.state.loading) return <div style={{ height: Business.getHeightContent() }}><Loading size="small" /></div>

    if (this.state.isShowDashboard) {
      return (
        <div className="row" style={{ marginTop: '10px' }}>
          <img src={srcSlideTwo} alt="logo" style={{ height: '600px', width: '100%' }} />
        </div>
      );
    }
    return (
      <div className="row" style={{ marginTop: '10px', minHeight: 500, width: '100%' }} />
    );
  }

  render() {
    // if (this.state.loading) return <div style={{ height: Business.getHeightContent() }}><Loading size="small" /></div>

    return (
      <div className="card" style={{ border: 'none', backgroundColor: '#F2F2F2' }}>
        <div className="header">
          {/* <h4 className="title">CAR</h4> */}
        </div>
        <div className="content table-responsive table-full-width">
          <div className="row">
            <div className="col-md-3">
              <div style={{ marginRight: 10, display: 'inline' }}>
                <label>Date</label>
              </div>
              <SingleDatePicker
                date={this.state.date}
                onDateChange={date => this.setState({ date }, () => { this.handleEffectShowDashboard(); })}
                focused={this.state.focused}
                onFocusChange={({ focused }) => this.setState({ focused })}
                showDefaultInputIcon
                isOutsideRange={() => false}
                inputIconPosition={'after'}
              />
            </div>

            <div className="col-md-6" />

            <div className="col-md-3" style={{ paddingTop: '10px' }}>
              <label>Currency unit: Billion VND</label>
            </div>
          </div>
          {this.renderDashboard()}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Dashboard/CreditRisk.js